import { render, staticRenderFns } from "./MyProfileProfessionalInformation.vue?vue&type=template&id=4579449e&scoped=true"
import script from "./MyProfileProfessionalInformation.vue?vue&type=script&lang=js"
export * from "./MyProfileProfessionalInformation.vue?vue&type=script&lang=js"
import style0 from "./MyProfileProfessionalInformation.vue?vue&type=style&index=0&id=4579449e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4579449e",
  null
  
)

export default component.exports